<template>
    <div class="topnav page-topnav" style="padding: 0 12px; max-height: none; overflow-y: visible">
        <div class="container-fluid">
            <nav class="navbar navbar-light navbar-expand topnav-menu">
                <div class="navbar-collapse align-items-center justify-content-between">
                    <ul class="navbar-nav">
                        <li class="nav-item">
                            <h6>{{ $root.text('IMG.LY template scenes', null, true) }}</h6>
                        </li>
                    </ul>
                    <ul class="navbar-nav">
                        <li class="nav-item" style="height: 36.5px">
                            <div style="position: absolute; height: 36.5px; right: 0">
                                <button
                                    v-if="$root.hasPermission('templates_import_img_ly_scenes')"
                                    type="button"
                                    class="btn btn-primary mr-2"
                                    data-toggle="modal"
                                    data-target="#img-ly-scene-import-modal"
                                    @click="resetImportScene()"
                                >
                                    <i class="far fa-file-import mr-1"></i> {{ $root.text('Import scene', null, true) }}
                                </button>
                            </div>
                        </li>
                    </ul>
                </div>
            </nav>
        </div>
    </div>
</template>

<script>
    export default {
        data () {
            return {
                //
            }
        },
        mounted () {
            //
        },
        methods: {
            resetImportScene: function () {
                $('#img-ly-scene-import-modal').modal('show');
                const appComponent = this.$root.findComponent(this.$root, 'main-app');
                if (appComponent) {
                    const scenesComponent = this.$root.findComponent(appComponent, 'img-ly-scenes');
                    const component = this.$root.findComponent(scenesComponent, 'img-ly-scene-import');
                    component.reset();
                }
            }
        }
    }
</script>
